(() => {
  let tail=Promise.resolve();
  window.pncMutate=action=>{const operation=tail.then(action);tail=operation.catch(()=>{});return operation;};
  window.pncFetch=(url,options={})=>{
    const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),20000);
    return fetch(url,{...options,credentials:'same-origin',signal:controller.signal}).finally(()=>clearTimeout(timer));
  };
  window.pncRefreshCart=async()=>{
    const response=await window.pncFetch(`${window.routes.cart_url}.js`,{cache:'no-store'});
    if(!response.ok)throw new Error('Cart unavailable');
    const cart=await response.json();
    const names=['cart-icon-bubble','cart-drawer','main-cart-items','main-cart-footer'];
    const url=new URL(window.routes.cart_url,location.origin);url.searchParams.set('sections',names.join(','));
    const sectionsResponse=await window.pncFetch(url,{cache:'no-store'});
    if(!sectionsResponse.ok)throw new Error('Cart view unavailable');
    const sections=await sectionsResponse.json();
    for(const [id,selector] of [['cart-icon-bubble','.shopify-section'],['cart-drawer','#CartDrawer'],['main-cart-items','.js-contents'],['main-cart-footer','.js-contents']]){
      if(!sections[id])continue;
      const source=new DOMParser().parseFromString(sections[id],'text/html').querySelector(selector);
      const target=id==='cart-drawer'?document.querySelector('#CartDrawer'):document.getElementById(id)?.querySelector(selector)||document.getElementById(id);
      if(source&&target)target.innerHTML=source.innerHTML;
    }
    document.querySelectorAll('cart-drawer,cart-items,#main-cart-footer').forEach(el=>el.classList.toggle('is-empty',cart.item_count===0));
    const drawer=document.querySelector('cart-drawer'),overlay=drawer?.querySelector('#CartDrawer-Overlay');
    overlay?.addEventListener('click',()=>drawer.close());
    return cart;
  };
  document.addEventListener('keydown',event=>{
    if(event.key!=='Escape')return;
    const open=document.querySelector('[data-pnc-menu][open]');
    if(open){open.open=false;open.querySelector('summary').focus();}
  });
  document.addEventListener('click',event=>document.querySelectorAll('[data-pnc-menu][open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false}));
  document.addEventListener('focusin',event=>document.querySelectorAll('[data-pnc-menu][open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false}));
  document.addEventListener('shopify:section:load',event=>{
    if(event.target.querySelector('#cart-icon-bubble'))document.querySelector('cart-drawer')?.setHeaderCartIconAccessibility();
  });
})();
